import { Injectable } from "@angular/core";
import * as _ from "lodash";
import { IBundleProduct, IProduct } from "../components/product-selection-modal/models/product-list.model";
import {v4 as uuidv4} from 'uuid';
import { UtilityService } from "src/app/inventory/sales-order/utils/utility.service";


@Injectable({
    providedIn: 'root'
})
export class ProductDataService {
    constructor(private utilityService : UtilityService) { }


    prepareProductsList(products: any[]): IProduct[] {
        return products.map(product => {

            /** Bundle Products */
            const bundleDetails: IBundleProduct[] = (product.bundleDetails || []).map(bProduct => {

                /** Kit/Bundle under Kit */
                const kitDetails: IBundleProduct[] = (bProduct.bundleDetails || []).map(kProduct => {
                    const bUomValue = kProduct.selectedUOM?.uomDetail?.value || 1;
                    return {
                        id: kProduct.productId,
                        uuid: uuidv4(),
                        itemNo: kProduct.itemNo,
                        hsnsac: kProduct.hsnsac,
                        description: kProduct?.itemDescription ?? "",
                        uom: kProduct.productUOM,
                        unit: kProduct.selectedUOM,
                        availabel: kProduct.avail,
                        ordQty: kProduct.bundleQty,
                        originalQty: kProduct.bundleQty,
                        bundleQty: kProduct.bundleQty,
                        cost: kProduct.salesPrice,
                        baseprice: kProduct.salesPrice,
                        price: kProduct.isCustom ? kProduct.priorityPrice : kProduct.bestPrice,
                        originalprice: kProduct.isCustom ? kProduct.priorityPrice : kProduct.bestPrice,
                        accountPriceTier: kProduct.accountProductPriceTiers,
                        isCustom: kProduct.isCustom,
                        discountTypeName: kProduct.tierTypeName,
                        selectedTierId: kProduct.selectedtierId,
                        locationId: kProduct.locationId,
                        typeId: kProduct.typeId,
                        discountType: kProduct?.productDiscount && kProduct?.productDiscount?.discount ? this.utilityService.prepareDiscountOptions([kProduct?.productDiscount?.discount])?.[0] ?? null : null,
                        taxType: null,
                        discount: kProduct?.productDiscount && kProduct?.productDiscount?.discount ? kProduct?.productDiscount?.discount?.discountValue ?? 0 : 0,
                        discountAmount: 0,
                        taxAmount: 0,
                        totalAvailInSelectedWareHouse: kProduct.avail,
                        totalQuantity: bUomValue * kProduct.bundleQty,
                        productCategory: kProduct.productCategory || [],
                        addQty: kProduct.addQty || 0,
                        costPrice: kProduct.buyPrice, //Cost Price for Purchase module
                        totalCostPrice: 0, 
                        trackingEnabled: kProduct.isTrackingRequired,
                        binDetails: kProduct.binDetail,
                        warehouseId: kProduct.warehouseId,
                        backOrderQty: 0,
                        additionalFeeType: kProduct?.productAdditionalCharges?.additionalFees ?? null,
                        additionalFee: kProduct?.productAdditionalCharges?.additionalFees?.discountValue ?? 0,
                        additionalFeeAmount: 0,
                        minPrice: 0,
                        minBaseSubtotal: 0,
                        isManualTaxApplied: false,
                    };
                });

                const bUomValue = bProduct.selectedUOM?.uomDetail?.value || 1;
                return {
                    id: bProduct.productId,
                    uuid: uuidv4(),
                    itemNo: bProduct.itemNo,
                    hsnsac: bProduct.hsnsac,
                    description: bProduct?.itemDescription ?? "",
                    uom: bProduct.productUOM,
                    unit: bProduct.selectedUOM,
                    availabel: bProduct.avail,
                    ordQty: bProduct.bundleQty,
                    originalQty: bProduct.bundleQty,
                    bundleQty: bProduct.bundleQty,
                    cost: bProduct.salesPrice,
                    baseprice: bProduct.salesPrice,
                    price: bProduct.isCustom ? bProduct.priorityPrice : bProduct.bestPrice,
                    originalprice: bProduct.isCustom ? bProduct.priorityPrice : bProduct.bestPrice,
                    accountPriceTier: bProduct.accountProductPriceTiers,
                    isCustom: bProduct.isCustom,
                    discountTypeName: bProduct.tierTypeName,
                    selectedTierId: bProduct.selectedtierId,
                    locationId: bProduct.locationId,
                    typeId: bProduct.typeId,
                    discountType: bProduct?.productDiscount && bProduct?.productDiscount?.discount ? this.utilityService.prepareDiscountOptions([bProduct?.productDiscount?.discount])?.[0] ?? null : null,
                    taxType: null,
                    discount: bProduct?.productDiscount && bProduct?.productDiscount?.discount ? bProduct?.productDiscount?.discount?.discountValue ?? 0 : 0,
                    discountAmount: 0,
                    taxAmount: 0,
                    bundleDetails: [...kitDetails],
                    allBundleProducts: [...kitDetails],
                    totalAvailInSelectedWareHouse: bProduct.avail,
                    totalQuantity: bUomValue * bProduct.bundleQty,
                    productCategory: bProduct.productCategory || [],
                    addQty: bProduct.addQty || 0,
                    costPrice: bProduct.buyPrice,
                    totalCostPrice: 0,
                    trackingEnabled: bProduct.isTrackingRequired,
                    binDetails: bProduct.binDetail,
                    warehouseId: bProduct.warehouseId,
                    backOrderQty: 0,
                    additionalFeeType: bProduct?.productAdditionalCharges?.additionalFees ?? null,
                    additionalFee: bProduct?.productAdditionalCharges?.additionalFees?.discountValue ?? 0,
                    additionalFeeAmount: 0,
                    minPrice: 0,
                    minBaseSubtotal: 0,
                    isManualTaxApplied: false,
                };
            });

            /** Products */
            const uomValue = product?.productUOM?.[0]?.uomDetail?.value || 1;
            return {
                id: product.productId,
                uuid: uuidv4(),
                itemNo: product.itemNo,
                hsnsac: product.hsnsac,
                description: product?.itemDescription ?? "",
                uom: product.productUOM,
                unit: product?.productUOM?.[0],
                availabel: product.avail,
                ordQty: 1,
                bundleQty: 1,
                originalQty: 1,
                cost: product.salesPrice,
                baseprice: product.salesPrice,
                price: product.isCustom ? product.priorityPrice : product.bestPrice,
                originalprice: product.isCustom ? product.priorityPrice : product.bestPrice,
                accountPriceTier: product.accountProductPriceTiers,
                isCustom: product.isCustom,
                discountTypeName: product.tierTypeName,
                selectedTierId: product.selectedtierId,
                locationId: product.locationId,
                typeId: product.typeId,
                discountType: product?.productDiscount && product?.productDiscount?.discount ? this.utilityService.prepareDiscountOptions([product?.productDiscount?.discount])?.[0] ?? null : null,
                taxType: null,
                discount: product?.productDiscount && product?.productDiscount?.discount ? product?.productDiscount?.discount?.discountValue ?? 0 : 0,
                discountAmount: 0,
                taxAmount: 0,
                bundleDetails: [...bundleDetails],
                allBundleProducts: [...bundleDetails],
                invoiceProductSerialDetails: [],
                totalAvailInSelectedWareHouse: product.avail,
                totalQuantity: uomValue * 1,
                productCategory: product.productCategory || [],
                addQty: product.addQty || 0,
                costPrice: product.buyPrice,
                totalCostPrice: 0,
                trackingEnabled: product.isTrackingRequired,
                warehouseId: product.warehouseId,
                binDetails: product.binDetail,
                backOrderQty: 0,
                isDuplicatedProduct: false,
                additionalFeeType: product?.productAdditionalCharges?.additionalFees ?? null,
                additionalFee: product?.productAdditionalCharges?.additionalFees?.discountValue ?? 0,
                additionalFeeAmount: 0,
                minPrice: 0,
                minBaseSubtotal: 0,
                isManualTaxApplied: false,
            };
        });
    }
}